import {authReducer} from "./Auth";
import {combineReducers} from "redux";

export const rootReducer = combineReducers({
    orderData: authReducer
})